import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

var moment = require('moment');
moment.locale('th');

Vue.use(require('vue-moment'), {
  moment
})

Vue.prototype.moment = window.moment = moment

Vue.prototype._ = window._ = {
  filter: require('lodash/filter'),
  find: require('lodash/find'),
  first: require('lodash/first'),
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
